var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_45",
    "data-name": "Group 45",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 257.34,
    height: 23.812,
    viewBox: "0 0 257.34 23.812",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 257.34,
    height: 23.812,
    fill: "#fff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M0,16.26v2.917H4.8V32.187H8.368V19.178h4.76V16.26Z",
    transform: "translate(0 -14.034)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M102.567,16.261v5.36a4,4,0,0,1,3.154-1.388,3.729,3.729,0,0,1,3.875,4.016v7.939h-3.274v-6.48c-.026-1.912-.479-2.6-1.772-2.6-1.315,0-1.983.929-1.983,2.794v6.29h-3.3V16.261Z",
    transform: "translate(-85.676 -14.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M186.185,19.251h-3.249v-2.99h3.249Zm0,12.937h-3.249V20.567h3.249Z",
    transform: "translate(-157.89 -14.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M218.248,45.607l-.046,1.984c.645-1.6,1.579-2.318,2.989-2.318a3.748,3.748,0,0,1,.672.071V48.4a3.153,3.153,0,0,0-.887-.095c-1.838,0-2.557.906-2.557,3.3v5.618h-3.373V45.607Z",
    transform: "translate(-185.603 -39.075)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M272.629,22.909c1.41.1,2.273,1.413,2.273,3.466,0,2.2-.863,3.49-2.365,3.49s-2.442-1.36-2.442-3.608c0-2.055.931-3.348,2.415-3.348Zm5.573-6.648h-3.349V21.5a4.336,4.336,0,0,0-3.13-1.265c-2.99,0-4.928,2.389-4.928,6.049,0,3.73,2.007,6.288,4.9,6.288a4.129,4.129,0,0,0,3.2-1.433v1.051h3.3Z",
    transform: "translate(-230.267 -14.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M396.175,23.529V19.158H399c2.034,0,2.846.6,2.846,2.125,0,1.581-1.007,2.246-3.347,2.246Zm0,2.9h2.391c2.178,0,2.466.313,2.895,3.253a4.906,4.906,0,0,0,.858,2.508h3.71a7.671,7.671,0,0,1-1.22-3.73c-.406-2.819-.718-3.346-2.37-3.846a3.549,3.549,0,0,0,2.872-3.828c0-2.967-1.865-4.522-5.407-4.522h-7.293V32.188h3.564Z",
    transform: "translate(-338.858 -14.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M495.475,51.728v.6a2.53,2.53,0,0,1-2.7,2.772c-.954,0-1.6-.5-1.6-1.27,0-.788.5-1.194,1.865-1.482.215-.045.645-.142,1.291-.307a5.174,5.174,0,0,0,1.147-.313m-3.968-2.39c.094-.959.836-1.531,2.056-1.531,1.078,0,1.795.455,1.795,1.148,0,.5-.337.741-1.174.86-2.941.456-3.779.644-4.784,1.15a3.069,3.069,0,0,0-1.6,2.865c0,2.3,1.626,3.779,4.114,3.779a5.506,5.506,0,0,0,3.635-1.36l.168.978h3.515a4.034,4.034,0,0,1-.434-2.322V49.983a4.455,4.455,0,0,0-.859-3.158,5.118,5.118,0,0,0-4.163-1.552c-3.274,0-5.283,1.53-5.354,4.065Z",
    transform: "translate(-421.013 -39.075)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M579.6,19.251h-3.251v-2.99H579.6Zm0,12.937h-3.251V20.567H579.6Z",
    transform: "translate(-497.437 -14.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M1729.493,11.907A11.906,11.906,0,1,1,1717.587,0a11.9,11.9,0,0,1,11.905,11.906",
    transform: "translate(-1472.152 -0.001)",
    fill: "#49a942"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M1528.29,11.907A11.906,11.906,0,1,1,1516.384,0a11.9,11.9,0,0,1,11.905,11.906",
    transform: "translate(-1298.496 -0.001)",
    fill: "#49a942"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M1327.088,11.907A11.906,11.906,0,1,1,1315.182,0a11.9,11.9,0,0,1,11.905,11.906",
    transform: "translate(-1124.841 -0.001)",
    fill: "#49a942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 3.272,
    height: 15.927,
    transform: "translate(83.311 2.226)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M678.44,19.281a3.1,3.1,0,0,0-3.254-2.461c-2.606,0-4.159,1.983-4.159,5.33,0,3.3,1.553,5.333,4.135,5.333a3.168,3.168,0,0,0,3.4-2.893l3.73.213c-.647,3.659-3.2,5.668-7.152,5.668-4.707,0-7.963-3.394-7.963-8.321,0-4.948,3.21-8.321,7.944-8.321,3.726,0,6.357,1.984,6.955,5.212Z",
    transform: "translate(-575.83 -11.936)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M788.861,45.607l-.049,1.984c.649-1.6,1.579-2.318,2.99-2.318a3.7,3.7,0,0,1,.67.071V48.4a3.12,3.12,0,0,0-.883-.095c-1.842,0-2.559.906-2.559,3.3v5.618h-3.373V45.607Z",
    transform: "translate(-678.09 -39.075)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M845.7,49.933h-4.784a2.444,2.444,0,0,1,2.413-2.079,2.346,2.346,0,0,1,2.371,2.079m3.441,2.511c0-.261.021-.454.021-.6,0-4.089-2.172-6.573-5.711-6.573a5.865,5.865,0,0,0-6.026,6.218c0,3.752,2.314,6.119,5.976,6.119,2.8,0,4.759-1.267,5.62-3.658l-3.32-.239a2.516,2.516,0,0,1-2.25,1.34,2.487,2.487,0,0,1-2.51-2.608Z",
    transform: "translate(-722.767 -39.075)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M937.2,51.728v.6a2.531,2.531,0,0,1-2.7,2.772c-.956,0-1.6-.5-1.6-1.27,0-.788.5-1.194,1.865-1.482.217-.045.646-.142,1.289-.307a5.174,5.174,0,0,0,1.149-.313m-3.97-2.39c.1-.959.839-1.531,2.058-1.531,1.075,0,1.794.455,1.794,1.148,0,.5-.335.741-1.174.86-2.94.456-3.777.644-4.782,1.15a3.057,3.057,0,0,0-1.6,2.865c0,2.3,1.624,3.779,4.108,3.779a5.487,5.487,0,0,0,3.635-1.36l.171.978h3.516a4.025,4.025,0,0,1-.435-2.322V49.983a4.462,4.462,0,0,0-.856-3.158,5.117,5.117,0,0,0-4.162-1.552c-3.276,0-5.286,1.53-5.357,4.065Z",
    transform: "translate(-802.261 -39.075)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M1020.786,25.7v2.512h-2.055v5.5c-.026.883.311,1.148,1.314,1.148a6.955,6.955,0,0,0,.907-.046v2.508l-.335.025a14.241,14.241,0,0,1-2.079.166,2.919,2.919,0,0,1-2.583-.929,3.558,3.558,0,0,1-.552-2.4V28.232h-1.674V25.7h1.674V22.2h3.3V25.7Z",
    transform: "translate(-874.937 -19.163)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M1075.92,19.251h-3.251v-2.99h3.251Zm0,12.937h-3.251V20.567h3.251Z",
    transform: "translate(-925.807 -14.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M1110.347,47.712,1106.4,59.332h-3.179l-3.972-11.621h3.469l2.056,7.8,2.1-7.8Z",
    transform: "translate(-948.748 -41.18)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M1181.058,49.933h-4.786a2.453,2.453,0,0,1,2.419-2.079,2.345,2.345,0,0,1,2.366,2.079m3.441,2.511c0-.261.024-.454.024-.6,0-4.089-2.175-6.573-5.715-6.573a5.865,5.865,0,0,0-6.026,6.218c0,3.752,2.322,6.119,5.979,6.119,2.8,0,4.757-1.267,5.62-3.658l-3.323-.239a2.528,2.528,0,0,1-4.759-1.268Z",
    transform: "translate(-1012.214 -39.075)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M1360.6,47.455c.043-2.467,1.431-3.855,3.822-3.855,2.238,0,3.656,1.2,3.656,3.06a2.366,2.366,0,0,1-1.51,2.414,2.5,2.5,0,0,1,1.912,2.672c0,2.195-1.685,3.678-4.149,3.678s-4.03-1.459-4.03-3.818v-.3l2.312-.118a1.915,1.915,0,0,0-.037.4,1.745,1.745,0,0,0,1.775,1.865,1.67,1.67,0,1,0-.124-3.331,2.672,2.672,0,0,0-.724.094V48.223a2.983,2.983,0,0,0,.623.081c1.041,0,1.652-.514,1.652-1.375a1.344,1.344,0,0,0-1.411-1.393c-1.021,0-1.51.666-1.51,2.045Z",
    transform: "translate(-1174.062 -37.631)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M1561.785,48.975V45.757h2.073c1.5,0,2.1.435,2.1,1.562,0,1.16-.737,1.656-2.462,1.656Zm0,2.127h1.754c1.6,0,1.816.225,2.137,2.389a3.524,3.524,0,0,0,.635,1.851h2.725a5.685,5.685,0,0,1-.9-2.744c-.3-2.07-.53-2.463-1.744-2.833a2.615,2.615,0,0,0,2.115-2.815c0-2.183-1.374-3.33-3.976-3.33h-5.371V55.342h2.622Z",
    transform: "translate(-1345.694 -37.648)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M1760.6,45.846a2.282,2.282,0,0,0-2.394-1.8c-1.917,0-3.061,1.462-3.061,3.921,0,2.424,1.145,3.929,3.041,3.929a2.322,2.322,0,0,0,2.5-2.136l2.742.161c-.475,2.687-2.358,4.169-5.257,4.169-3.466,0-5.857-2.5-5.857-6.122s2.35-6.124,5.835-6.124c2.75,0,4.693,1.458,5.117,3.838Z",
    transform: "translate(-1512.402 -36.111)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1b94da2d1a2bbff11817fef716ae5d2b.svg";
export { ForwardRef as ReactComponent };